export const useIncludedLoading = ({
  loadingErrorName = 'loadingError',
  loadingName = 'loading',
} = {}) => ({
  props: {
    [loadingErrorName]: {
      type: Object,
      default: () => ({}),
    },
    [loadingName]: Boolean,
  },
});
